import { useContext, useEffect, useState } from 'react';

import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import { GameContext } from '@/state/contexts';
import { createPossibleChoicesForCard, getCardMetadata } from '@/util/card';
import { logg } from '@/util/logg';
import { playCard } from '@lc/const/socketEvent';
import '@/style/HandModal.css';
import { createActionParams } from '@lc/interface/actionParams/factory';

/**
 * Modal for decisions on cards for player
 * Given a selected card id,
 * We could split this into 2 parts
 * clientCardDecisionModal
 * and serverCardDecisionModal
 * one picks up cardId from client's hand modal
 * other from the server via hooks
 * we could have a source of cardId toggle to go from client to server
 * where client picks up selectedCardId
 * and if from server we could have decisionServerCardId
 * so the modal shows if player is activePlayerId
 * then again if either decision modal was launched OR server set turnType to "decisionCardResolution"
 *
 * -- OR, we can have 2 separate modals that feed info into a single base guy via params --
 * BUT 2 separate for now so you don't go crazy and optimize later
 *
 * source (if any)
 * target (if any)
 * decision (if any) - will be from drop down as array of choices from card metadata
 *
 * if any are present, run decision modal.
 *
 */

// TODO lay out all cards with choices, see the ins and outs for each, should only need sourceId, targetId,
const DecisionModal = ({ onClose }) => {
	const {
		currPlayer,
		// players,
		playerStateArray,
		// setSelectedAction,
		// selectedAction,
		// setSelectedActionCost,
		// selectedActionCost,
		// setSelectedCard,
		selectedCard,
		// setSelectedCardId,
		selectedCardId,
		paymentObject, // if paying for card, send a full object with payment AND decision. If no payment object, choice is result of card resolving
		performAction,
	} = useContext(GameContext);

	const [card, setCard] = useState();
	const [sourceRequired, setSourceRequired] = useState(false);
	const [targetRequired, setTargetRequired] = useState(false);
	const [choiceRequired, setChoiceRequired] = useState(false);
	const [sourceId, setSourceId] = useState(-1);
	const [targetId, setTargetId] = useState(-1);
	const [choiceInt, setChoiceInt] = useState(0);

	// TODO if a turntype that's not a normalSeasonalTurn, take ques from server sent info to display the decision and its choices
	// should this just be a new modal?
	// TODO disable close modal if not normalSeasonalTurn
	// break out decision modal into different types of subsets to make it easier?

	useEffect(() => {
		// if client, we use selectedCard and selectedCardId
		// if server, we use use     serverDecisionPlayerId,
		// serverDecisionCardId,
		// serverDecisionTargetIds,
		// the more I think about it the more I think I'm right
		// communal decision component
		// load into decision component based on data
		// because we have 2 different scenarios for loading into decision
		// 1 is I am choosing something
		// the other is a server trigger
		// then funnel data via 2 components into 1 via params.
		// but, again, f it for now

		const card = getCardMetadata(selectedCardId);
		setCard(card);
		let cObj = createPossibleChoicesForCard(card); // TODO set decisions from current card

		setTargetRequired(cObj.targetReq);
		setSourceRequired(cObj.sourceReq);
		setChoiceRequired(cObj.choiceReq);

		setSourceId(currPlayer.playerId);
		for (let i = 0; i < playerStateArray.length; i++) {
			if (playerStateArray[i].playerId !== currPlayer.playerId) {
				setTargetId(playerStateArray[i].playerId);
				logg('currTarget 1');
				logg(playerStateArray[i].playerId);
				break;
			}
		}
		setChoiceInt(0);
	}, []);

	function makeChoice(e) {
		e.preventDefault();

		sendClientDecision();
		closeModal();
	}

	function sendClientDecision() {
		logg('sending decision monsour DECISION MODAL');

		logg('currPlayer', currPlayer);
		logg('sourceId', sourceId);
		logg('targetId', targetId);
		logg('selectedCard', selectedCard);
		logg('selectedCardId', selectedCardId);

		const actionParams = createActionParams(
			selectedCardId,
			paymentObject,
			sourceId,
			targetId,
			choiceInt
		);

		performAction(playCard, actionParams);
	}

	// how payments are reset
	function closeModal() {
		onClose();
	}

	// if color is NOT already attached to a player, return it
	// TODO we need a target array for neighbor resolutions
	const targetFilter = (target) => {
		if (currPlayer.playerId === target.playerId) return;
		return target;
	};

	const handleSourceChange = (event) => {
		logg('currSource decision');
		const newSourceId = parseInt(event.target.value, 10) ?? -1;
		logg(newSourceId);
		setSourceId(newSourceId);
	};

	const handleTargetChange = (event) => {
		logg('currTarget decision');
		const newTargetId = parseInt(event.target.value, 10) ?? -1;
		logg(newTargetId);
		setTargetId(newTargetId);
	};

	const handleDecisionChange = (event) => {
		logg('handleDecisionChange decision');
		const newChoiceInt = parseInt(event.target.value, 10) ?? -1;
		logg(newChoiceInt);
		setChoiceInt(newChoiceInt);
	};

	if (!card) return;

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<h2>MAKE A CHOICE</h2>
				{/** Boolean thing here for PR turn selection */}
				<SeasonalCard cardId={selectedCardId} width={0} height={0} />
				{sourceRequired && (
					<div>
						Source:
						<select
							id="sourceSelect"
							value={sourceId}
							onChange={handleSourceChange}
						>
							{playerStateArray.map((source) => (
								<option
									key={source.playerId}
									value={source.playerId}
								>
									{source.color}
								</option>
							))}
						</select>
					</div>
				)}
				{targetRequired && (
					<div>
						Target:
						<select
							id="targetSelect"
							value={targetId}
							onChange={handleTargetChange}
						>
							{playerStateArray
								.filter(targetFilter)
								.map((target) => (
									<option
										key={target.playerId}
										value={target.playerId}
									>
										{target.color}
									</option>
								))}
						</select>
					</div>
				)}
				{choiceRequired && (
					<div>
						Decision:
						<select
							id="DecisionSelector"
							value={choiceInt}
							onChange={handleDecisionChange}
						>
							{card.decision.map((d) => (
								<option key={d.text} value={d.id}>
									{d.text}
								</option>
							))}
						</select>
					</div>
				)}
				<button
					value={0}
					onClick={(e) => makeChoice(e, selectedCardId)}
				>
					Confirm Choice
				</button>
			</div>
		</div>
	);
};

export default DecisionModal;
